import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {UpdateItemsInsideNodeMessage} from '@models/sidebar/update-items-inside-node-message';

@Injectable({
  providedIn: 'root'
})
export class UpdateItemsInsideNodeService {

  private behaviourSubject = new BehaviorSubject(new UpdateItemsInsideNodeMessage(null));
  currentMessage = this.behaviourSubject.asObservable();

  broadcast(message: UpdateItemsInsideNodeMessage) {
    this.behaviourSubject.next(message);
  }
}
